import React from 'react';
import { Modal } from 'react-bootstrap';
import { MentionsInput, Mention } from 'react-mentions';
import { useTranslation } from 'react-i18next';
import Loader from '../../../Components/Utility/Loader/Loader';

const defaultStyle = {
  control: {
    backgroundColor: '#fff',
    fontSize: 14,
    fontWeight: 'normal',
  },
  '&singleLine': {
    display: 'inline-block',
    width: 180,
    highlighter: {
      padding: 1,
    },
    input: {
      border: 'none',
      marginTop: 10,
    },
  },
  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
      width: '300px',
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#f5f5f5',
      },
      color: '#000',
    },
  },
};

function SubmitPopupEmail({ toggle, mainState, handleOnChange, downloadSubmitTechpack }) {
  const { emailModal, toErr, bccErr, ccErr, to, bcc, cc, message, userList } = mainState;
  const { t } = useTranslation('common');

  const suggestedMentions = 'Suggested mentions';
  return (
    <Modal className="common-custom-modal modal-medium" onHide={toggle} show={emailModal} size="lg">
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_POP_UP_EMAIL.COMPOSE_EMAIL')}</Modal.Title>
        <span onClick={toggle} className="icon-close cursor-pointer ml-auto" />
      </Modal.Header>
      {mainState?.loader ? (
        <Loader />
      ) : (
        <Modal.Body>
          <div className="modal-inner-data">
            <div className="input-group common-input-control form-floating-label fixed-label ">
              <MentionsInput
                className="form-control"
                singleLine
                value={to}
                onChange={(_ev, _newValue, newPlainTextValue) => {
                  handleOnChange(newPlainTextValue, 'to');
                }}
                style={defaultStyle}
                placeholder={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_POP_UP_EMAIL.PLACEHOLDER')}
                a11ySuggestionsListLabel={suggestedMentions}
                // customSuggestionsContainer={(children)=><div cl>{children}</div>}
              >
                <Mention trigger="@" data={userList} renderSuggestion={(val) => <div>{`${val.name} ${val.label}`}</div>} />
              </MentionsInput>
              <label>{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_POP_UP_EMAIL.TO')}</label>
            </div>
            {toErr && <small className="error-message ml-1">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_POP_UP_EMAIL.PLEASE_ADD_ATLEAST_EMAIL')}</small>}
            <div className="input-group common-input-control form-floating-label fixed-label ">
              <MentionsInput
                className="form-control"
                singleLine
                value={cc}
                onChange={(_ev, _newValue, newPlainTextValue) => {
                  handleOnChange(newPlainTextValue, 'cc');
                }}
                style={defaultStyle}
                placeholder={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_POP_UP_EMAIL.CC_PLACEHOLDER')}
                a11ySuggestionsListLabel={suggestedMentions}
              >
                <Mention trigger="@" data={userList} renderSuggestion={(val) => <div>{`${val.name} ${val.label}`}</div>} />
              </MentionsInput>
              <label>{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_POP_UP_EMAIL.CC')}</label>
            </div>
            {ccErr && <small className="error-message ml-1">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_POP_UP_EMAIL.ADD_VALID_EMAIL')}</small>}
            <div className="input-group common-input-control form-floating-label fixed-label ">
              <MentionsInput
                className="form-control"
                singleLine
                value={bcc}
                onChange={(_ev, _newValue, newPlainTextValue) => {
                  handleOnChange(newPlainTextValue, 'bcc');
                }}
                style={defaultStyle}
                placeholder={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_POP_UP_EMAIL.BCC_PLACEHOLDER')}
                a11ySuggestionsListLabel={suggestedMentions}
              >
                <Mention trigger="@" data={userList} renderSuggestion={(val) => <div>{`${val.name} ${val.label}`}</div>} />
              </MentionsInput>
              <label>{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_POP_UP_EMAIL.BCC')}</label>
            </div>
            {bccErr && <small className="error-message ml-1">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_POP_UP_EMAIL.ADD_VALID_EMAILS')}</small>}
            <div className="input-group form-floating-label fixed-label ">
              <input value={message} type="text" name="name" className="form-control" onChange={(e) => handleOnChange(e.target.value, 'message')} />
              <label>{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_POP_UP_EMAIL.MESSAGE')}</label>
            </div>
          </div>
          <div className="common-model-footer mt-16">
            <button aria-label="button" type="button" onClick={() => downloadSubmitTechpack('submit')} className="btn p-0">
              <i className="icon-Tick-1 text-grey f-20" />
            </button>
          </div>
        </Modal.Body>
      )}
    </Modal>
  );
}

export default SubmitPopupEmail;
